var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReadersActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.0001 16.667C20.7334 16.667 18.1667 19.2337 18.1667 22.5003C18.1667 24.2503 18.1667 26.5837 18.1667 28.917",
    stroke: "#CC0000",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.8333 22.5003C29.8333 19.2337 27.2667 16.667 24 16.667",
    stroke: "#CC0000",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.8333 22.5C29.8333 24.8333 29.8333 27.1667 29.25 29.5",
    stroke: "#CC0000",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9999 19.583C22.3666 19.583 21.0833 20.8663 21.0833 22.4997C21.0833 24.2497 21.0833 26.583 21.0833 28.333",
    stroke: "#CC0000",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9167 22.4997C26.9167 20.8663 25.6333 19.583 24 19.583",
    stroke: "#CC0000",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9166 22.5C26.9166 24.8333 26.9166 27.1667 26.3333 30.0833",
    stroke: "#CC0000",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0001 22.5C24.0001 24.8333 24.0001 27.75 23.4167 30.6667",
    stroke: "#CC0000",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8333 24.8333C15.8333 22.5 16.4166 17.8333 19.9166 15.5",
    stroke: "#CC0000",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M28.0833 15.5C30.4166 16.9 32.1666 19.5833 32.1666 22.5",
    stroke: "#CC0000",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReadersActive);
export default __webpack_public_path__ + "static/media/readers-active.87f24b1bd868c1a667b6bb4b598b0a1d.svg";
export { ForwardRef as ReactComponent };